import {
  Center,
  HTMLChakraProps,
  VStack,
  Text,
  Button,
} from '@chakra-ui/react';
import { ReactComponent as SignIcon } from '../assets/sign.svg';
// sign message modal
const SignMessageModal = ({
  handleClick,
  ...rest
}: { handleClick: () => void } & HTMLChakraProps<'div'>) => {
  return (
    <Center
      flexDir={'column'}
      pos={'absolute'}
      top={'50%'}
      left="50%"
      transform={'translate(-50%, -50%)'}
      textAlign={'center'}
      color="c-103"
      borderRadius={10}
      bg="c-109"
      boxShadow="10px 20px 50px 0px #0000004D"
      py={'2rem'}
      px={'6.5rem'}
      gap={2}
      {...rest}
      zIndex={90}
    >
      <VStack spacing={'10px'}>
        <SignIcon width={'6rem'} />
        <Text>You need to sing message first to play the game</Text>
      </VStack>
      <Button variant={'normal'} w="13.125rem" mt={7} onClick={handleClick}>
        SIGN MESSAGE
      </Button>
    </Center>
  );
};

export default SignMessageModal;
